import React from 'react';
import Indexs from '../Quotation/index';
import Title from '../../title';
import Permission from '../../../functions/permission';

class Invoice extends React.Component {

  state = {
    menuPermission: []
  }

  componentDidMount() {
    this.getPermission();
  }

  getPermission() {
    if (this.props.type == 'quotation') {
      let menuPermission = Permission('invoice', this.props.menus);
      this.setState({ menuPermission })
    }
    else {
      let menuPermission = Permission('quotation', this.props.menus);
      this.setState({ menuPermission })
    }
  }

  render() {
    return (
      <div>
        <Title title={'Invoice'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Indexs type="quotation" menus={this.props.menus} display='none'
              menuPermission={this.state.menuPermission}
              columnName={'Invoice No'} value="I" viewcontrol={this.state.viewcontrol}
              editcontrol={this.state.editcontrol} cancelcontol={this.state.invoicecancel} />
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Invoice;
